class ViewSwitcher extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    document.addEventListener('DOMContentLoaded', () => {
      this.els?.trigger?.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    })
  }

  onTriggerClick (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-pressed', false)
    })

    triggerEl.setAttribute('aria-pressed', true)

    if (this.dataset.media === 'mobile') {
      this.setCartAttribute('collection_view_mobile', triggerEl.dataset.view)
      this.externalEls?.grid?.element.setAttribute(
        'data-mobile-view',
        triggerEl.dataset.view,
      )
    }

    if (this.dataset.media === 'desktop') {
      this.setCartAttribute('collection_view_desktop', triggerEl.dataset.view)
      this.externalEls?.grid?.element.setAttribute(
        'data-desktop-view',
        triggerEl.dataset.view,
      )
    }

    const customEvent = new CustomEvent('plpViewChange', {
      detail: {
        view: triggerEl.dataset.view,
      },
    })

    window.dispatchEvent(customEvent)

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }
}

if (!customElements.get('view-switcher')) {
  customElements.define('view-switcher', ViewSwitcher)
}
